import GradientBorderRadius from "@/ui/gradient-border-radius";
import PortfolioHeader from "./portfolio-header";
import PortfolioLayout from "./portfolio-layout";
import WalletPositions from "@/features/wallet-positions/wallet-positions";
import BuySellBotTokenProvider from "../token-v2/providers/buy-sell-token-provider";

const PortfolioPage = () => {
  return (
    <BuySellBotTokenProvider>
      <GradientBorderRadius className="w-full" overflow>
        <PortfolioHeader />
        <WalletPositions />
        <PortfolioLayout />
      </GradientBorderRadius>
    </BuySellBotTokenProvider>
  );
};

export default PortfolioPage;
